import { belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';

import type Agreement from './agreement';
import NdaSignature from './nda-signature';

export default class VisitorNdaSignature extends NdaSignature {
  // @ts-expect-error - TS doesn't like this being declared here because the superclass has a different value (which is OK because it's a separate model)
  declare [Type]: 'visitor-nda-signature';

  @belongsTo('agreement', { async: true, inverse: 'visitorSignature' }) declare agreement: AsyncBelongsTo<Agreement>;
}
